import { ErrorWithTitle } from "@components/error-boundary/error-types";
import { getErrorDisplayMarkup } from "@components/error-boundary/error-boundary-utils";
import { SanitizedHtmlTag } from "@components/sanitized-html-tag";
import { NotificationDialog } from "@flat-ui";

interface Props {
  /** An error with user readable text and actual error */
  error: ErrorWithTitle;

  /** Callback when Close button is clicked */
  onClose(): void;
}

/** Displays an error message in a Dialog with a close button. */
export function ErrorDialog({ error, onClose }: Props): React.JSX.Element {
  return (
    <NotificationDialog
      notificationType="error"
      open={true}
      onCancel={onClose}
      title={error.title}
    >
      <SanitizedHtmlTag markup={getErrorDisplayMarkup(error.error)} />
    </NotificationDialog>
  );
}
